import HTTP from "@/http-common";

export const state = {
  impersonating: null
};

export const getters = {
  impersonating: state => {
    return state.impersonating;
  }
};

export const mutations = {
  SET_IMPERSONATING(state, data) {
    state.impersonating = data;
  }
};

export const actions = {
  async setImpersonate({ commit, dispatch }, args) {
    try {
      let result = await HTTP.post(`OptusNBN/SetImpersonate`, args);
      commit(`SET_IMPERSONATING`, result.data.data);
    } catch (e) {
      dispatch(`processLoader/setProcessInactive`, {}, { root: true });
      return Promise.reject(e);
    }
  },
  async getImpersonate({ commit, dispatch }) {
    try {
      let result = await HTTP.get(`OptusNBN/GetImpersonate`);
      let impersonateData = result.data ? result.data.data : null;
      commit(`SET_IMPERSONATING`, impersonateData);
      if (result.data && result.data.groups != null) {
        dispatch("auth/setRoles", result.data.groups, { root: true });
      } else {
        dispatch("auth/markRolesResolved", null, { root: true });
      }
    } catch (e) {
      dispatch("auth/markRolesResolved", null, { root: true });
      dispatch(`processLoader/setProcessInactive`, {}, { root: true });
      return Promise.reject(e);
    }
    // return new Promise((resolve, reject) => {
    //     HTTP.get(`OptusNBN/GetImpersonate`)
    //     .then(result => {
    //         if(result.data.success){
    //             commit(`SET_IMPERSONATING`, result.data.data);
    //         }
    //     })
    //     .catch(e => {
    //         let message = "";
    //         if(e.response.data === "") message = e.message;
    //         else message = e.response.data;
    //         dispatch(
    //             "httpResponse/setHttpResponse",
    //             { text: message, color: "error" },
    //             { root: true }
    //         );
    //     })
    // });
  },
  async removeImpersonate({ commit, dispatch, state }) {
    try {
      let result = await HTTP.post(`OptusNBN/RemoveImpersonate`, {
        id: 0,
        impersonateEmail: state.impersonating.impersonateEmail
      });

      if (!result.data.success) commit("SET_IMPERSONATING", null);
    } catch (e) {
      dispatch(`processLoader/setProcessInactive`, {}, { root: true });
      return Promise.reject(e);
    }
  }
};
